const MONTHS = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic']

const hhmm = (d: Date) =>
  `${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`

/** "Hoy, 14:20" · "Ayer, 19:40" · "8 ago 2026, 14:20" */
export function formatWhen(iso: string | null | undefined, now = new Date()): string {
  if (!iso) return '—'
  const d = new Date(iso)
  if (Number.isNaN(d.getTime())) return '—'
  const diffH = (now.getTime() - d.getTime()) / 3_600_000
  if (diffH >= 0 && diffH < 12) return `Hoy, ${hhmm(d)}`
  if (diffH >= 12 && diffH < 36) return `Ayer, ${hhmm(d)}`
  return `${d.getDate()} ${MONTHS[d.getMonth()]} ${d.getFullYear()}, ${hhmm(d)}`
}

export function formatDate(iso: string | null | undefined): string {
  if (!iso) return '—'
  const d = new Date(iso)
  if (Number.isNaN(d.getTime())) return '—'
  return `${d.getDate()} ${MONTHS[d.getMonth()]} ${d.getFullYear()}`
}

const SMALL_WORDS = new Set(['de', 'del', 'la', 'las', 'los', 'el', 'y', 'e'])

/**
 * `status1` llega crudo y en mayúsculas ("EDS : VIÑA DEL MAR/AGUA SANTA").
 * Se humaniza solo para mostrar; el dato de origen no se toca.
 */
export function prettyStation(value: string | null | undefined): string {
  if (!value) return '—'
  const m = /^\s*EDS\s*:?\s*(.*)$/i.exec(value)
  const body = m?.[1] ?? value
  const titled = body
    .split('/')
    .map((seg) =>
      seg
        .trim()
        .toLowerCase()
        .split(/\s+/)
        .filter(Boolean)
        .map((w, i) => (i > 0 && SMALL_WORDS.has(w) ? w : w.charAt(0).toUpperCase() + w.slice(1)))
        .join(' '),
    )
    .join(' / ')
  return m ? `EDS ${titled}` : titled
}
